import axios, { AxiosHeaders } from 'axios';
import { ApiUrl } from './constants';
const baseURL = ApiUrl.DOMAIN;
const instance = axios.create({
  baseURL
});
instance.interceptors.request.use(config => {
  if (config.headers) {
    // eslint-disable-next-line no-param-reassign
    config.headers['content-type'] = 'application/json';
  } else {
    // eslint-disable-next-line no-param-reassign
    config.headers = new AxiosHeaders({
      'content-type': 'application/json'
    });
  }
  return config;
});

// エラーハンドリングは providers/axiosError.ts に移譲
// instance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.log(error.response?.status);
//     console.log(error.response);
//   }
// );

export default instance;